<template>
  <div class="md-timeline">
    <div v-if="timelineTitle" class="timeline-title">{{ timelineTitle }}</div>
    <div class="timeline-list">
      <div v-for="(item, idx) in timelineData" :key="idx" class="timeline-item">
        <div class="timeline-dot-wrap">
          <div class="timeline-dot" :class="item.status || 'pending'"></div>
          <div v-if="idx < timelineData.length - 1" class="timeline-line"></div>
        </div>
        <div class="timeline-content">
          <div class="timeline-label">{{ item.title || item.label || item.name || item }}</div>
          <div v-if="item.description" class="timeline-desc">{{ item.description }}</div>
          <div v-if="item.time" class="timeline-time">{{ item.time }}</div>
          <div v-if="item.meta && typeof item.meta === 'object'" class="timeline-meta">
            <span v-for="(val, key) in item.meta" :key="key" class="meta-item">
              <span class="meta-key">{{ key }}:</span>
              <span class="meta-val">{{ val }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdTimelineLog',
  props: {
    title: { type: String, default: '' },
    items: { type: String, default: '' },
    data: { type: String, default: '' },
    _rawJson: { type: String, default: '' },
    _componentKey: { type: String, default: '' }
  },
  computed: {
    timelineTitle() {
      const raw = this._parseJson(this._rawJson) || {}
      return this.title || raw.title || ''
    },
    timelineData() {
      const raw = this._parseJson(this._rawJson) || {}
      const rawItems = this._parseJson(this.items) ||
        this._parseJson(this.data) ||
        this._parseJson(raw.items) ||
        this._parseJson(raw.data) ||
        []
      return Array.isArray(rawItems) ? rawItems : []
    }
  },
  methods: {
    _parseJson(value) {
      if (!value) return null
      if (typeof value === 'object') return value
      if (typeof value !== 'string') return null
      const cleaned = value.replace(/\n/g, '')
      try {
        return JSON.parse(cleaned)
      } catch {
        try {
          const normalized = cleaned.replace(/'/g, '"').replace(/,\s*([}\]])/g, '$1')
          return JSON.parse(normalized)
        } catch {
          return null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-timeline {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
  margin: 8px 0;
  background: #fff;
}

.timeline-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  margin-bottom: 12px;
}

.timeline-list {
  display: flex;
  flex-direction: column;
}

.timeline-item {
  display: flex;
  gap: 12px;
  position: relative;
}

.timeline-dot-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d9d9d9;
  flex-shrink: 0;
  margin-top: 4px;

  &.success { background: #52c41a; }
  &.running { background: #3370ff; animation: pulse 1.5s infinite; }
  &.error { background: #f5222d; }
  &.pending { background: #d9d9d9; }
}

.timeline-line {
  width: 1px;
  flex: 1;
  min-height: 20px;
  background: #e8e8e8;
}

.timeline-content {
  flex: 1;
  padding-bottom: 16px;
  min-width: 0;
}

.timeline-label {
  font-size: 13px;
  color: #1f2329;
  font-weight: 500;
}

.timeline-desc {
  font-size: 12px;
  color: #646a73;
  margin-top: 4px;
  line-height: 1.5;
}

.timeline-time {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
}

.timeline-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
}

.meta-item {
  font-size: 12px;
}

.meta-key {
  color: #999;
}

.meta-val {
  color: #1f2329;
  margin-left: 4px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
